import { site } from "../content/site";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-slate-950 text-slate-400">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-2.5">
          <Logo />
          <span className="font-display font-bold text-white tracking-tight text-lg">
            votanphuoc<span className="text-teal-400">.space</span>
          </span>
        </div>
        <p className="mt-4 text-sm leading-relaxed max-w-xs">{site.tagline} — built for people who use AI every day.</p>
      </div>

      <nav aria-label="Footer">
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Navigate</h3>
        <ul className="mt-4 space-y-2.5">
          {site.nav.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                data-testid={`footer-link-${item.testId.replace("nav-link-", "")}`}
                className="text-sm hover:text-teal-300 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400 rounded"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Contact</h3>
        <a
          href={`mailto:${site.email}`}
          data-testid="footer-email-link"
          className="mt-4 inline-block text-sm text-slate-300 hover:text-teal-300 transition-colors break-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400 rounded"
        >
          {site.email}
        </a>
        <p data-testid="footer-legal-name" className="mt-5 text-sm leading-relaxed">
          Legal entity: <span className="text-slate-200 font-medium">{site.legalEntity}</span>
          <br />
          Brand and operator are the same entity — one name, one accountable team.
        </p>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row gap-2 items-start sm:items-center justify-between">
        <p className="text-xs">© 2026 {site.legalEntity}. All rights reserved.</p>
        <p className="text-xs font-mono tracking-wide text-slate-500">{site.url}</p>
      </div>
    </div>
  </footer>
);
